<template>
	<div class="clearfix">
		<form action="" style="padding: 0; maring: 0;" ref="searchForm">
			<div :class="prefixCls+ '-wrapper'" :style="groupStyle">
				<common-icon type="ios-search" :class="prefixCls + '-icon'" style="left: 8px;"></common-icon>
				<Input :class="prefixCls + '-input-wraper'"
                    :elementId="prefixCls + '-input'"
					:value='searchValue' 
					:placeholder="placeholder" 
					:clearable="true"
					@input="onInput" >
				</Input>
				<Button type='primary' :class="prefixCls + '-btn'" @click='search'>搜索</Button>
			</div>
		</form>
	</div>
</template>
<script>
	import CommonIcon from '../common-icon'
	import Input from '../input'
	import Button from '../button'

	export default {
		name: "TableSearcher",

		components: {
			CommonIcon,
			Button,
			Input
		},

		model: {
			prop: 'searchValue',
			event: 'input'
		},

		props:{
			searchValue: String,
			placeholder: {
				type: String,
				default: ''
			},
			width: {
				type: Number,
				default: 292
			},
			// 是否去掉首尾空格
			trim: {
				type: Boolean,
				default: true
			}
		},
		computed:{
			prefixCls(){
				return "ivu-table-searcher"
			},
			groupStyle(){
				return {
					width: this.width + "px"
				}
			}
		},
		methods:{
			onInput(value){
				// 去掉首尾空格
				this.$emit("input", this.trim ? value.trim() : value)
				// 清空
				if(value == ""){
					this.$emit("clear")
				}
			},
			search(e){
				e.preventDefault()
				this.$emit("search")
			}
		},
		mounted() {
			this.$refs.searchForm.onsubmit = this.search
	    }
	}
</script>